import { t } from '../../utils/i18n';
import { updateEvevntStatus } from "../../services/selectTimeService";
import { SCREEN } from "../../utils/constants";
import { appUrl, eventId, form, locations, selectedLocation, setEventPayload, setEventRoom } from "../../utils/variables";
import { loadAppointmentConfirmed } from "../../views/components/appointmentConfirmed";
import { toastError } from "../../views/components/error";
import { appointmentConfirmedListeners } from "./appointmentConfirmedListeners";
import { loadCardCollection } from "./cardCollectionListeners";
import { navigate } from "./movePages";

export function appointmentSummaryListeners() {
    const btn = document.querySelector('.appointment-summary__continue-btn');
    btn.querySelector('.text').innerHTML = form?.appointment_channel?.auto_confirmation ? t('confirm') : t('request_appointment');
    if(!form?.appointment_channel?.auto_confirmation) btn.style.width = '60%';
    btn.addEventListener('click', onHandleAppointmentSummaryContinueBtnClickEvent);
    const addressSpan = document.querySelector('.appointment-summary__container .appointment-location .detail-info span:last-child');
    if (addressSpan) {
        addressSpan.addEventListener('click', copyAddressHandler);
    }
}

async function onHandleAppointmentSummaryContinueBtnClickEvent() {
    if (form?.appointment_channel?.collect_card_on_booking && form?.stripe_publishable_key) {
        loadCardCollection();
        return;
    }

    let loaderIcon = document.querySelector('.appointment-summary__continue-btn .loader__icon');
    try {
        document.querySelector('.appointment-summary__continue-btn')?.classList.add('disabled');
        document.querySelector('.appointment-summary__continue-btn .loading__wrapper')?.classList.remove('hidden');
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<img src="${appUrl}/assets/icons/rolling.png" />`);
        }

        let updateEvevntStatusRes = await updateEvevntStatus(eventId);

        // Slot → intake handoff (see selectTimeActions.js).
        const intakeUrl = updateEvevntStatusRes?.data?.intake_redirect_url;
        if (intakeUrl) {
            window.parent.location.href = intakeUrl;
            return;
        }

        setEventRoom(updateEvevntStatusRes.data.event_room || null);
        setEventPayload(updateEvevntStatusRes.data);
        // Always show appointment thank you / event summary (confirmed or request)
        loadAppointmentConfirmed();
        appointmentConfirmedListeners();
        navigate(SCREEN.APPOINTMENT_CONFIRMED);
    } catch (error) {
        toastError(error.response?.data?.message || "Something went wrong");
    } finally {
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
        }
        document
            .querySelector('.appointment-summary__continue-btn .loading__wrapper')?.classList.add('hidden');
        document
            .querySelector('.appointment-summary__continue-btn')?.classList.remove('disabled');
    }
}

function copyAddressHandler() {
    let selectedLocationObj = locations.find(e => e.id === selectedLocation);
    let address = selectedLocationObj?.address1 ? `${selectedLocationObj.address1}, ` : '';
    let city = selectedLocationObj?.city ? `${selectedLocationObj.city}, ` : '';
    let state = selectedLocationObj?.state ? `${selectedLocationObj.state}, ` : '';
    let country = selectedLocationObj?.country ? `${selectedLocationObj.country}` : '';
    navigator.clipboard.writeText(`${address}${city}${state}${country}`);
}
